import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiClipboard, FiFilePlus, FiFileText, FiPackage, FiUsers } from 'react-icons/fi';
import { useControlAuth } from '../../ControlAuthContext';
import './ControlPanel.css';

const API_BASE = 'https://valleyapi-dr9y.onrender.com';
const ControlPanel = () => {
  const { user } = useControlAuth();
  const [summary, setSummary] = useState({ orders: 0, activeOrders: 0, quotes: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('controlToken');
    Promise.all([
      axios.get(`${API_BASE}/api/control/orders`, { headers: { Authorization: `Bearer ${token}` } }),
      axios.get(`${API_BASE}/api/control/quotes?page=1&limit=1`, { headers: { Authorization: `Bearer ${token}` } }),
    ]).then(([ordersResponse, quotesResponse]) => {
      const orders = ordersResponse.data.orders || [];
      setSummary({ orders: orders.length, activeOrders: orders.filter((order) => order.status !== 'Delivered').length, quotes: Number(quotesResponse.data.totalQuotes || 0) });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const quickLinks = [
    { to: '/control/orders-control/create', icon: FiPackage, title: 'Create order', text: 'Register a new client order.' },
    { to: '/control/pending-quotes/create', icon: FiFilePlus, title: 'Create quote', text: 'Prepare a new product quotation.' },
    { to: '/control/pending-quotes', icon: FiFileText, title: 'Review quotes', text: 'Follow up on recent quotations.' },
  ];
  if (user.accesstype === 0) quickLinks.push({ to: '/control/user-control', icon: FiUsers, title: 'Manage team', text: 'Create and review control users.' });

  return <div className="control-dashboard">
    <header className="control-dashboard-header"><div><span>Control center</span><h1>Good to see you, {user.name || user.userid}</h1><p>Here is the latest activity in your operations workspace.</p></div><span className="control-access-badge">{user.accesstype === 0 ? 'Full access' : 'Sales access'}</span></header>
    <section className="control-summary-grid" aria-label="Workspace summary"><article><span><FiClipboard /></span><div><strong>{loading ? '—' : summary.orders}</strong><small>Total orders</small></div></article><article><span><FiPackage /></span><div><strong>{loading ? '—' : summary.activeOrders}</strong><small>Active orders</small></div></article><article><span><FiFileText /></span><div><strong>{loading ? '—' : summary.quotes}</strong><small>Quote groups</small></div></article></section>
    <section className="control-quick-section"><div className="control-section-heading"><h2>Quick actions</h2><p>Continue with the most common control tasks.</p></div><div className="control-quick-grid">{quickLinks.map(({ to, icon: Icon, title, text }) => <Link key={to} to={to}><span><Icon /></span><div><strong>{title}</strong><p>{text}</p></div><FiArrowRight /></Link>)}</div></section>
  </div>;
};

export default ControlPanel;
